import styles from "../styles/Button.module.css";
import { Link } from "react-router-dom";

export default function Button({
  children,
  href,
  onClick,
  variant = "btnBase",
  size = "btnAuto",
  type = "button",
  disabled = false,
}) {
  if (href) {
    return (
      <Link
        to={href}
        className={`${styles.btn} ${styles[variant]} ${styles[size]}`}
      >
        {children} <span className={styles.chev}>›</span>
      </Link>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${styles.btn} ${styles[variant]} ${styles[size]}`}
      disabled={disabled}
    >
      {children} <span className={styles.chev}>›</span>
    </button>
  );
}
